module.exports = __webpack_public_path__ + "img/IC_plan_planeado_white.9ce41b62.svg";